<div class="is-flex">
    <ng-content></ng-content>
    <span *ngIf="sorting !== 'none'" class="icon">
        <isav-icon *ngIf="sorting === 'asc'" icon="chevron-down"></isav-icon>
        <isav-icon *ngIf="sorting === 'desc'" icon="chevron-up"></isav-icon>
    </span>
</div>
